/**
 * 忘记密码页面
 */
import './index.less';

import { FC, lazy, Suspense, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';

import EmailOrMobile from './comps/EmailOrMobile';
import RetrieveEntryUI from './indexUI';
// import NewPassword from './comps/NewPassword';
import { IEmailOrMobile } from './types';

const NewPassword = lazy(() => import('./comps/NewPassword'));

const SecurityComponent = lazy(() => import('./comps/SecurityComponent'));

const Retrieve: FC = () => {
  const [$t] = useI18nContext();
  const [step, setStep] = useState<number>(0);
  const [info, setInfo] = useState<IEmailOrMobile>({ tapKey: '1' });
  const [risk_token, setRiskToken] = useState<any>();
  const [showRiskToken, setShowRiskToken] = useState<any>();

  const _setRiskToken = (value: string) => {
    setRiskToken(value);
    if (value) {
      nextStep();
    }
  };

  const showSecurity = (info: IEmailOrMobile, risk_token: string) => {
    setInfo(info);
    setShowRiskToken(risk_token);
  };

  const nextStep = (info?: IEmailOrMobile) => {
    info && setInfo(info);
    setStep(1);
  };

  return (
    <RetrieveEntryUI>
      <Suspense fallback={''}>
        {showRiskToken && (
          <SecurityComponent
            info={info}
            setShowRiskToken={setShowRiskToken}
            callback={_setRiskToken}
            showRiskToken={showRiskToken}
          />
        )}
      </Suspense>
      {step === 0 && (
        <EmailOrMobile
          nextStep={nextStep}
          risk_token={risk_token}
          showSecurity={showSecurity}
        />
      )}
      <Suspense fallback={''}>
        {step === 1 && <NewPassword info={info} risk_token={risk_token} />}
      </Suspense>
    </RetrieveEntryUI>
  );
};

export default Retrieve;
